import React, { useState } from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { trackFormTriggerClicked } from "@/lib/posthog";

interface KeyEvent {
  id: number;
  title: string;
  image: string;
  category: string;
  imagePosition?: string;
}

interface KeyEventCardProps {
  event: KeyEvent;
  onOpenForm?: () => void;
}

const KeyEventCard: React.FC<KeyEventCardProps> = ({ event, onOpenForm }) => {
  const [imageError, setImageError] = useState(false);

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    trackFormTriggerClicked("Faire une demande", "key-event-card", "button");
    if (onOpenForm) {
      onOpenForm();
    }
  };

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="group cursor-pointer flex-shrink-0 w-full">
      <AspectRatio ratio={4/5} className="overflow-hidden rounded-xl relative">
        {imageError ? (
          <div className="w-full h-full bg-gray-200 flex items-center justify-center text-gray-500">
            Image non disponible
          </div>
        ) : (
          <img
            src={event.image}
            alt={event.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            style={event.imagePosition ? { objectPosition: event.imagePosition } : undefined}
            onError={handleImageError}
            loading="lazy"
            decoding="async"
          />
        )}
        
        {/* Overlay au survol */}
        <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <Button
            variant="outline"
            className="bg-white text-gray-900 hover:bg-white/90 border-none"
            onClick={handleButtonClick}
          >
            Faire une demande
          </Button>
        </div>
      </AspectRatio>
      
      {/* Titre sous l'image */}
      <div className="mt-3 px-1">
        <h3 className="text-base font-normal text-gray-900">{event.title}</h3>
      </div>
    </div>
  );
};

export default KeyEventCard;
